import { Button } from 'grommet'
import Link from 'next/link'
import styled, { css } from 'styled-components'

export const ButtonStyles = css`
  align-items: center;
  box-shadow: none;
  display: flex;
  justify-content: center;
  min-height: 50px;
  text-align: center;
  text-decoration: none;
  transition: all 0.2s ease-out 0s;
  width: 100%;

  &:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 4px;
  }

  ${({ theme, $backgroundColor, $marginTop, $textColor, width }) => css`
    ${theme.getTypography('desktop', 'button', 'normal')}

    background-color: ${theme.colors[$backgroundColor]};
    color: ${theme.colors[$textColor]};
    margin-top: ${$marginTop};
    max-width: ${width};
  `}
`

export const StyledLink = styled(Link)`
  ${ButtonStyles}
`

export const StyledButton = styled(Button)`
  ${ButtonStyles}
`
